import { html } from 'lit';
import type { AppElement } from '../app';

export const cookiePolicyTemplate = function (this: AppElement) {

    return html`
    <main class="policy">
        <div class="column">
            <ill-cookie-policy></ill-cookie-policy>
        </div>
    </main>
    `;
};
